export const validateGuest = (guest) => {
  if (!guest) return false;
  if (!guest[0]) return false;
  if (!guest[0].name) return false;
  if (!guest[0].gender) return false;
  if (!guest[0].region) return false;
  if (!guest[0].yearRoc) return false;
  if (!guest[0].month) return false;
  if (!guest[0].day) return false;
  if (!guest[0].weightKg) return false;
  if (!guest[0].heightCm) return false;
  return true
}